export const GRID_CONFIG = {
  COLS: 112,
  ROWS: 96,
  CELL_SIZE: 1, // 각 격자 칸의 기본 크기
  CANVAS_WIDTH: 112,
  CANVAS_HEIGHT: 96
};

export const COLORS = {
  GRID_LINE: '#cccccc',
  SUB_GRID_LINE: '#e0e0e0',
  GRID_HIGHLIGHT: '#4CAF50',
  BACKGROUND: '#87CEEB'
};